import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { nonprofitsData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function NonprofitsPage() {
    return <SolutionTemplate {...nonprofitsData} />;
}
